<template>
	<section class="page skills-page p-3">
		
		<div class="skill-wrap pt-5 pb-5">
			<div class="row">
				<div class="col-12 col-md-6 arrow-top-left">
					<h2 class="p-3 text-dark-blue">My skills</h2>
				</div>
				<div class="col-12 col-md-6 p-3" v-for="(skill, skillID) in skills" :key="skillID">
					<div class="skill-block p-3">
						<div class="row m-0 h-100 align-items-center">
							<div class="col-12 col-sm-5 p-0">
								<img :src="skill.url" alt="">
							</div>
							<div class="col-12 col-sm-7 h-100 pt-3 p-sm-0">
								<h3 class="mb-3"><b class="text-red mr-2">#</b>{{ skill.title }}</h3>
								<div class="skill-block-list">
									<ul class="list-group list-group-flush mb-3">
										<li
											class="list-group-item"
											v-for="(tech, techId) in skill.technology"
											:key="techId"
										>
											<i :class="tech.icon" class="mr-2"></i>
											<span>{{tech.description}}</span><small class="ml-2" v-if="tech.more">{{tech.more}}</small>

										</li>
									</ul>
								</div>
								<div class="row align-items-center">
									<div class="col-auto">
										<i class="far fa-frown"></i>
									</div>
									<div class="col p-0">
										<div class="progress">
											<div role="progressbar" :aria-valuenow="skill.procent" aria-valuemin="0" aria-valuemax="100" class="progress-bar bg-violet" :style="{ width: skill.procent + '%' }"></div>
										</div>
									</div>
									<div class="col-auto">
										<i class="far fa-smile"></i>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	data () {
		return {
			id: 1,
			skills: [
				{
					title: 'coding',
					procent: '85',
					url: require('../assets/images/svg/icons/coding.svg'),
					technology: [
						{
							icon: 'text-danger fab fa-html5',
							description: 'HTML 5'
						},
						{
							icon: 'text-primary fab fa-css3-alt',
							description: 'CSS',
							more: '(SASS / SCSS)'
						},
						{
							icon: 'text-warning fab fa-js-square',
							description: 'JavaScript'
						},
						{
							icon: 'text-success fab fa-vuejs',
							description: 'VueJS'
						},
					]
				},
				{
					title: 'optimization',
					procent: '80',
					url: require('../assets/images/svg/icons/optimization.svg'),
					technology: [
						{
							icon: 'text-primary fas fa-tachometer-alt',
							description: 'google page speed'
						},
						{
							icon: 'text-success fas fa-tasks',
							description: 'W3C valid'
						},
					]
				},
				{
					title: 'design',
					procent: '75',
					url: require('../assets/images/svg/icons/design.svg'),
					technology: [
						{
							icon: 'text-danger fab fa-adobe',
							description: 'Photoshop / Illustrator'
						},
						{
							icon: 'text-warning fab fa-sketch',
							description: 'Scetch'
						},
					]
				}
			]
		}
	},
	methods: {
		onClickChild () {
			this.$emit('clicked', {
				page_id: this.id,
				next_page: '/portfolio',
				prev_page: '/'
			})
		},
	},
	mounted() {
		this.$nextTick(function() {
			this.onClickChild()
		})
	},
}
</script>



// WEBPACK FOOTER //
// src/pages/skills.vue